// @flow

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { createFragmentContainer, graphql } from 'react-relay';

import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { ModalBody } from 'dibs-elements/exports/ModalBody';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton';
import { ModalContainer } from 'dibs-elements/exports/ModalContainer';
import { Spinner } from 'dibs-elements/exports/Spinner';

import TagProject from './TagProject';

import styles from './styles/TagProjectModal.scss';

const messages = {
    title: (
        <FormattedMessage
            id="dc.ProjectForms.TagProjectModal.title"
            defaultMessage="Manage Project Tags"
        />
    ),
};

type TagProjectModalProps = {
    isOpen?: boolean,
    item?: mixed,
    onClose: () => void,
    onDone: Function,
    userId: string,
    viewer?: mixed,
};

export function TagProjectModal(props: TagProjectModalProps) {
    const { isOpen, onClose } = props;

    return (
        <ModalContainer
            isOpen={!!isOpen}
            modalPosition="center"
            onClose={onClose}
            modalClass={styles.modalContainer}
        >
            <BarHeader title={messages.title} />
            <ModalCloseButton onClick={onClose} />
            <ModalBody>
                {props.item && props.viewer ? (
                    <TagProject {...props} />
                ) : (
                    <Spinner containerClass={styles.loadingSpinner} dark />
                )}
            </ModalBody>
        </ModalContainer>
    );
}

const Component = TagProjectModal;
export { Component };

TagProjectModal = createFragmentContainer(TagProjectModal, {
    viewer: graphql`
        fragment TagProjectModal_viewer on Viewer {
            ...TagProject_viewer
        }
    `,
    item: graphql`
        fragment TagProjectModal_item on Item {
            ...TagProject_item
        }
    `,
});

export default TagProjectModal;
